import FadeInSection from '../../../components/feature/FadeInSection';

const documents = [
  '独身証明書、または戸籍謄本、戸籍抄本（3ヶ月以内に発行された原本）',
  '卒業証明書原本または卒業証書の写し（短大卒以上の方）',
  '身分証明書（運転免許証 or 保険証のコピー）',
  '住民票、または光熱費の明細（3か月以内に発行された原本）',
  '収入証明書（直近の源泉徴収票や確定申告書などの写し）※女性は任意',
  '医師、弁護士、その他国家資格それに準ずる資格をお持ちの場合は、その証明書の写し',
  '写真（契約締結後に、おススメのフォトスタジオをご案内可能です）',
];

const steps = [
  {
    number: 'STEP 1',
    label: 'ご予約',
    icon: 'ri-phone-line',
    color: '#e8934e',
    bg: '#fff8f2',
    borderColor: '#e8934e',
    image:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/enrollment-flow-1.jpeg',
    content: (
      <div>
        <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: '16px' }}>
          まずは安心してご相談いただけるよう、事前のご予約をお願いしております。
        </p>
        <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: '16px', marginTop: '10px' }}>
          ご連絡は、下記の方法よりご都合に合わせてお選びいただけます。
        </p>
        <ul className="mt-4 space-y-2">
          {[
            { icon: 'ri-phone-line', text: 'お電話' },
            { icon: 'ri-global-line', text: 'ホームページからのお問い合わせ' },
            { icon: 'ri-chat-smile-2-line', text: 'LINE公式アカウント' },
          ].map((item) => (
            <li key={item.text} className="flex items-center gap-2">
              <span className="flex items-center justify-center w-6 h-6" style={{ color: '#e8934e' }}>
                <i className={`${item.icon} text-base`}></i>
              </span>
              <span style={{ color: '#4a3728', fontSize: '15px', fontWeight: '500' }}>{item.text}</span>
            </li>
          ))}
        </ul>
        <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: '16px', marginTop: '14px' }}>
          小さなご不安やご質問でも大丈夫です。どうぞお気軽にお問い合わせください。
        </p>
      </div>
    ),
  },
  {
    number: 'STEP 2',
    label: '無料相談',
    icon: 'ri-chat-smile-line',
    color: '#5a9e6f',
    bg: '#f2f8f4',
    borderColor: '#5a9e6f',
    image:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/enrollment-flow-2.jpeg',
    content: (
      <div>
        <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: '16px' }}>
          ご不安なことや気になることなど、どんなことでもゆっくりお話しいただけます。約60分のお時間の中で、ご状況やご希望をお伺いしながら、無理のない形でご案内いたします。
        </p>
        <ul className="mt-5 space-y-3">
          {[
            { icon: 'ri-map-pin-line', text: '都内・近郊の方は対面にて、落ち着いてお話しいただける場所で直接お会いしてご相談いただけます。' },
            { icon: 'ri-video-chat-line', text: 'ご希望に応じてオンライン（ZOOM）でのご相談も承っております。' },
          ].map((item) => (
            <li key={item.icon} className="flex items-start gap-3">
              <span className="flex items-center justify-center w-6 h-6 mt-0.5 shrink-0" style={{ color: '#5a9e6f' }}>
                <i className={`${item.icon} text-base`}></i>
              </span>
              <span style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '1.85' }}>{item.text}</span>
            </li>
          ))}
        </ul>
        <div
          className="mt-5 px-4 py-3 rounded-lg text-sm flex items-center gap-2"
          style={{ background: '#f2f8f4', color: '#3d7a55', border: '1px solid #b8ddc8' }}
        >
          <span className="flex items-center justify-center w-5 h-5 shrink-0">
            <i className="ri-shield-check-line text-base"></i>
          </span>
          無理な勧誘は一切ございませんので、ご安心ください。
        </div>
      </div>
    ),
  },
  {
    number: 'STEP 3',
    label: 'ご入会',
    icon: 'ri-file-text-line',
    color: '#8b4513',
    bg: '#fff8f2',
    borderColor: '#d4a574',
    image:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/enrollment-flow-3.jpeg',
    content: null,
  },
];

export default function EnrollmentFlowSection() {
  return (
    <section className="section-padding" style={{ background: '#fffaf6' }}>
      <div className="content-width">
        <FadeInSection className="text-center mb-16">
          <p
            className="inline-block px-4 py-1 rounded-full mb-4 text-sm font-bold"
            style={{ background: '#fff8f2', color: '#8b4513', border: '1px solid #d4a574' }}
          >
            3つのステップ
          </p>
          <h2 style={{ color: '#4a3728' }}>ご入会までの流れ</h2>
          <p style={{ color: '#6b5a4e', marginTop: '12px', fontSize: '17px' }}>
            ご不明な点はいつでもお気軽にご相談ください
          </p>
        </FadeInSection>

        <div className="space-y-16">
          {steps.map((step, index) => (
            <FadeInSection key={step.number} delay={index * 100}>
              <div
                className={`flex flex-col lg:flex-row items-start gap-10 ${
                  index % 2 !== 0 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                {/* Image */}
                <div className="w-full lg:w-[460px] shrink-0">
                  <div className="w-full h-[280px] rounded-2xl overflow-hidden">
                    <img
                      src={step.image}
                      alt={step.label}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  {/* Step badge */}
                  <span
                    className="inline-block px-4 py-1.5 rounded-full text-sm font-bold text-white mb-5"
                    style={{ background: step.color }}
                  >
                    {step.number}
                  </span>

                  {/* Title */}
                  <div className="flex items-center gap-3 mb-5">
                    <span
                      className="flex items-center justify-center w-11 h-11 rounded-full shrink-0"
                      style={{ background: step.bg }}
                    >
                      <i className={`${step.icon} text-2xl`} style={{ color: step.color }}></i>
                    </span>
                    <h3 style={{ color: '#4a3728', fontSize: '26px', fontWeight: '700' }}>
                      {step.label}
                    </h3>
                  </div>

                  {/* Body */}
                  {step.content}

                  {/* Step 3 special: document list */}
                  {index === 2 && (
                    <div>
                      <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: '16px' }}>
                        ご納得いただいたうえで、ご入会のお手続きを進めさせていただきます。お手続きにあたっては、いくつか必要書類のご準備をお願いしております。ご不明な点は、その都度わかりやすくご説明いたしますのでご安心ください。
                      </p>
                      <p
                        className="mt-4 mb-3 font-bold"
                        style={{ color: '#4a3728', fontSize: '15px' }}
                      >
                        ご準備いただくもの
                      </p>
                      <div
                        className="rounded-xl p-6"
                        style={{ background: '#fff', border: '2px solid #e8c9a0' }}
                      >
                        <ul className="space-y-3">
                          {documents.map((doc, i) => (
                            <li key={i} className="flex items-start gap-3">
                              <span
                                className="mt-1 flex items-center justify-center w-5 h-5 rounded-full shrink-0 text-xs font-bold text-white"
                                style={{ background: '#d4a574', minWidth: '20px' }}
                              >
                                {i + 1}
                              </span>
                              <span style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '1.75' }}>
                                {doc}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Arrow connector */}
              {index < steps.length - 1 && (
                <div className="flex justify-center mt-10">
                  <div
                    className="flex items-center justify-center w-10 h-10 rounded-full"
                    style={{ background: '#e8d8cc' }}
                  >
                    <i className="ri-arrow-down-line text-xl" style={{ color: '#8b4513' }}></i>
                  </div>
                </div>
              )}
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}
